import Head from 'next/head';
import PropTypes from 'prop-types';
import React from 'react';
import WowModal from '../../WowModal';
import VipPaymentModule from './VipPaymentModule';

const PaymentVipModal = ({
  currentRef,
  deviceData,
  failedExpressBuy = false,
  isAuthCheckFinished,
  isAuthenticated,
  orderCompleteHandler,
  orderFailedHandler,
  paymentInstruments,
  setShowPaymentModal,
  showPaymentModal,
  setShowPaywall,
  vipDealData,
}) => {
  const orderSummary = {
    basketDiscountForExistingVipUser: 0,
    currency: vipDealData?.currency,
    displaySaving: false,
    finalOrderAmount: vipDealData?.price,
    finalPostageAmount: 0,
    orderSummaryIdentifier: '4a73d6a2-3188-4406-b690-28bd6f362fe4',
    postageDiscountItemThreshold: null,
    postageOnCheckoutRule: 9,
    postageOnRedemption: false,
    totalAdminFee: 0,
    totalGiftPackAmount: 0,
    totalGiftWrapAmount: 0,
    totalMerchantAmount: 0,
    totalOrderAmount: vipDealData?.price,
    totalPostageAmount: 0,
    totalPostageDiscount: 0,
    totalPromoCodeDiscount: 0,
    totalSavingAmount: 0,
    totalWalletAmount: 0,
    totalWalletApplicableOrderAmount: 0,
  };
  const basketProducts = [
    {
      adminFee: 0,
      availabilityDatesCount: null,
      business: vipDealData?.business?.name,
      category: vipDealData?.category,
      checkInDate: null,
      checkOutDate: null,
      closingDate: vipDealData?.closingDate,
      dealId: vipDealData?.id,
      deliveryOptionType: null,
      depositProduct: null,
      discount: 0,
      discountPercentage: 0,
      displayDiscount: false,
      finalDealOrderAmount: vipDealData?.price,
      finalProductAmount: vipDealData?.price,
      friendlyName: vipDealData?.emailSubject,
      gift: false,
      giftClaim: false,
      gifting: {
        gift: false,
        giftPackProductId: null,
        type: 'none',
      },
      giftPack: false,
      giftWrap: false,
      highFraudRisk: false,
      id: vipDealData?.products[0]?.id,
      image: null,
      imageUrl: vipDealData?.previewImageThumbUrl,
      live: true,
      originalPrice: vipDealData?.price,
      payDeposit: false,
      postagePrice: 0,
      preOrderEndDate: null,
      price: vipDealData?.price,
      productDeliveryOptions: [],
      promoCodeDiscountAmount: 0,
      purchasable: true,
      purchaseCap: vipDealData?.purchaseCap,
      quantity: 1,
      soldOut: vipDealData?.soldOut,
      status: vipDealData?.status,
      subcategory: vipDealData?.subCategory,
      timestamp: [2_023, 5, 2, 14, 52, 56],
      title: vipDealData?.friendlyName,
      totalAdminFee: 0,
      totalProductAmount: vipDealData?.price,
      totalRemainingForDay: null,
      totalRemainingForWeek: null,
    },
  ];

  const onModalHide = () => {
    setShowPaymentModal(false);
    setShowPaywall(true);
  };

  return (
    <>
      <Head>
        <script defer src="https://pay.google.com/gp/p/js/pay.js" />
      </Head>
      <WowModal
        ariaLabelledBy=""
        backdrop="static"
        backdropClassName="vip-payment"
        centered
        container={currentRef}
        extraClasses="range-modal"
        failedExpressBuy={failedExpressBuy}
        setShowModal={onModalHide}
        showCloseButton
        showHeader
        showModal={showPaymentModal}
        size="md"
        title
        vipPayment
      >
        <VipPaymentModule
          basketProducts={basketProducts}
          deviceFingerprintId={deviceData}
          failedExpressBuy={failedExpressBuy}
          finalOrderAmount={orderSummary?.finalOrderAmount}
          isAuthCheckFinished={isAuthCheckFinished}
          isAuthenticated={isAuthenticated}
          orderCompleteHandler={orderCompleteHandler}
          orderFailedHandler={orderFailedHandler}
          orderSummary={orderSummary}
          paymentInstruments={paymentInstruments}
          setShowPaymentModal={setShowPaymentModal}
          vipPayment
        />
      </WowModal>
      <style jsx>{`
        .vip-payment {
          background-color: rgba(0, 0, 0, 0.8);
        }
      `}</style>
    </>
  );
};
PaymentVipModal.propTypes = {
  currentRef: PropTypes.object,
  deviceData: PropTypes.string,
  failedExpressBuy: PropTypes.bool,
  isAuthCheckFinished: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
  orderCompleteHandler: PropTypes.func,
  orderFailedHandler: PropTypes.func,
  paymentInstruments: PropTypes.array,
  setShowPaymentModal: PropTypes.func,
  setShowPaywall: PropTypes.func,
  showPaymentModal: PropTypes.bool,
  vipDealData: PropTypes.object,
};

export default PaymentVipModal;
